import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevicesComponent } from '../devices/devices.component';
import { FirmwaresComponent } from '../firmwares/firmwares.component';
import { ErrorComponent } from '../shared/components/error/error.component';
import { AppGuard } from '../app.guard';
import { BaseComponent } from './base.component';
import { UserRoles } from '../users';

const routes: Routes = [
    {
        path: '',
        component: BaseComponent,
        children: [
            { path: 'devices', component: DevicesComponent, canActivate: [AppGuard] },
            {
                path: 'firmwares',
                component: FirmwaresComponent,
                data: { neededPermissions: [UserRoles.LCO_GET_3] },
                canActivate: [AppGuard],
            },
            {
                path: 'sim-cards',
                loadChildren: () => import('../sim-cards/sim-cards.module').then((m) => m.SimCardsModule),
                data: { neededPermissions: [UserRoles.LCO_GET_2] },
                canActivate: [AppGuard],
                canLoad: [AppGuard],
            },
            { path: 'error-page', component: ErrorComponent },
            { path: '**', redirectTo: 'devices' },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BaseRoutingModule {}
